module.exports = __webpack_public_path__ + "static/media/image8_eng.9812c422.png";